import React, { useState } from "react";
import { FaUser, FaUsers, FaRegFileAlt, FaCreditCard, FaWhatsapp, FaHistory } from "react-icons/fa";
import "./TallyPrimePlan.css";
import { useNavigate } from "react-router-dom";
import { color } from "framer-motion";

const TallyPrimePlan = () => {
  const navigate = useNavigate();

  const handleBuyNowClick = () => {
    navigate("/contact");
  };

  return (
    <div className="tally-rental-wrapper">
      <div className="rental-container">
        
        {/* ── Header ── */}
        <header className="rental-intro">
          <div className="header-badge">Flexible Licensing</div>
          <h1>TallyPrime Rental Solutions</h1>
          <p>Short-term licenses tailored for seasonal peaks, audits, and temporary business requirements.</p>
        </header>

        {/* ── Rental Grid ── */}
        <div className="rental-modern-grid">
          {/* Silver Rental */}
          <div className="rental-modern-card">
            <div className="card-top-accent silver"></div>
            <div className="card-inner">
              <div className="card-visual">
                <img src="/images/silver.png" alt="TallyPrime Silver" className="rental-product-img silver-img" />
              </div>
              <div className="card-header">
                <div className="icon-wrapper">
                  <FaUser />
                </div>
                <h3>Silver Rental</h3>
                <span className="user-type">Single User Edition</span>
              </div>
              
              <div className="duration-section">
                <p className="section-label">Available Terms</p>
                <div className="duration-pills">
                  <span className="pill">1 Month</span>
                  <span className="pill">3 Months</span>
                  <span className="pill">12 Months</span>
                </div>
              </div>

              <div className="card-price-info">
                <span className="price-label">Inquire for current rates</span>
              </div>

              <button className="rental-action-btn" onClick={handleBuyNowClick}>
                Get Started
              </button>
            </div>
          </div>

          {/* Gold Rental */}
          <div className="rental-modern-card featured">
            <div className="card-top-accent gold"></div>
            <div className="card-inner">
              <div className="card-visual">
                <img src="/images/GOLD.png" alt="TallyPrime Gold" className="rental-product-img" />
              </div>
              <div className="card-header">
                <div className="icon-wrapper">
                  <FaUsers />
                </div>
                <h3>Gold Rental</h3>
                <span className="user-type">Multi-User Edition</span>
              </div>
              
              <div className="duration-section">
                <p className="section-label">Available Terms</p>
                <div className="duration-pills">
                  <span className="pill">1 Month</span>
                  <span className="pill">3 Months</span>
                  <span className="pill">12 Months</span>
                </div>
              </div>

              <div className="card-price-info">
                <span className="price-label">Inquire for current rates</span>
              </div>

              <button className="rental-action-btn featured-btn" onClick={handleBuyNowClick}>
                Get Started
              </button>
            </div>
          </div>
        </div>

        {/* ── WhatsApp Section ── */}
        <section className="whatsapp-integration-section">
          <header className="whatsapp-header">
            <div className="header-badge wa" style={{color:"green"}}>Official Integration</div>
            <h2><span style={{color:"green", marginRight:"10px"}}><FaWhatsapp size={40}/></span>  WhatsApp for Business</h2>
            <p>Reliable messaging solutions integrated directly into your TallyPrime workflow.</p>
          </header>

          <div className="rental-modern-grid">
            {/* Wallet Recharge */}
            <div className="rental-modern-card">
              <div className="card-inner">
                <div className="card-header">
                  <div className="icon-wrapper wa">
                    <FaCreditCard />
                  </div>
                  <h3>Wallet Recharge</h3>
                  <span className="user-type">Continuous Communication</span>
                </div>
                
                <div className="feature-description">
                  <p>Flexible recharge options based on your messaging volume. Maintain uninterrupted party communication.</p>
                </div>

                <div className="card-price-info">
                  <span className="price-label">Contact for Recharge Rates</span>
                </div>

                <button className="rental-action-btn" onClick={handleBuyNowClick}>
                  Recharge Now
                </button>
              </div>
            </div>

            {/* Subscription Renewal */}
            <div className="rental-modern-card">
              <div className="card-inner">
                <div className="card-header">
                  <div className="icon-wrapper wa">
                    <FaHistory />
                  </div>
                  <h3>Annual Renewal</h3>
                  <span className="user-type">Yearly Subscription</span>
                </div>
                
                <div className="feature-description">
                  <p>Keep your WhatsApp Business API active and secure with our hassle-free annual renewal service.</p>
                </div>

                <div className="card-price-info">
                  <span className="price-label">Request Renewal Quote</span>
                </div>

                <button className="rental-action-btn" onClick={handleBuyNowClick}>
                  Renew Now
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TallyPrimePlan;
